<template>
  <div class="coupon-dia">
    <van-popup v-model="showCouponPopup" position="bottom" @close="close" v-if="validCouponListSort">
      <div class="title">{{ $t('lang.giftSign.coupon') }}</div>
      <van-tabs v-model="active" swipeable>
        <van-tab
          v-for="tabOption in tebTit"
          :title="tabOption.id == 0 ? `${tabOption.tit0}(${validCouponListSort.length})` : `${tabOption.tit1}(${expiredCouponList.length})`"
          :key="tabOption.id"
        >
          <!-- 有效优惠券 -->
          <div v-if="tabOption.id == 0" class="tab tab1">
            <div class="coupon" v-for="(item, index) in validCouponListSort" :key="index" @click="chooseCoupon(item, index)">
              <img class="coupon-bg" src="./images/coupon_bg.png" />
              <div class="left">
                <div class="left-num">
                  <img class="money-icon" :src="getMatchImg('coins')" alt="" />
                  <span class="money-num">+{{ item.amount }}</span>
                </div>
                <div class="dis-text">
                  <span class="text">{{ $t('lang.coupon.extra') }} {{ item.amount }}</span>
                  <span class="text-tip" style="color: #999999">
                    {{ $t('lang.coupon.desc1') }}
                    {{ item.minUseAmount }}
                    <img :src="getMatchImg('coin')" />
                    {{ $t('lang.coupon.desc2') }}
                  </span>
                </div>
              </div>
              <div class="right">
                <div class="coupon-num">
                  <van-icon v-if="chooseCouponId && chooseCouponId == item.couponRecordId" class="radio-checked" name="checked" />
                  <div v-else class="radio"></div>
                  <span class="text">
                    {{ handleTime9(item.expiredTime) }}
                  </span>
                </div>
              </div>
            </div>
            <div class="no-coupons" v-if="validCouponListSort.length == 0">{{ $t('lang.intimate.noCouponTip') }}</div>
          </div>
          <!-- 过期优惠券 -->
          <div v-if="tabOption.id == 1" class="tab tab2">
            <div class="coupon expired-coupon for-vava" v-for="(item, index) in expiredCouponList" :key="index">
              <div class="left">
                <div class="left-num">
                  <img class="money-icon" :src="getMatchImg('coins')" alt="" />
                  <span class="money-num">+{{ item.amount }}</span>
                </div>
                <div class="dis-text">
                  <p class="text">{{ $t('lang.coupon.extra') }} {{ item.amount }}</p>
                  <p class="text-tip">
                    {{ $t('lang.coupon.desc1') }}
                    {{ item.minUseAmount }}
                    <img :src="getMatchImg('coin')" />
                    {{ $t('lang.coupon.desc2') }}
                  </p>
                </div>
              </div>
              <div class="right">
                <div class="coupon-num">
                  <div class="expired">{{ $t('lang.intimate.expired') }}</div>
                  <span class="text">
                    {{ handleTime9(item.expiredTime) }}
                  </span>
                </div>
              </div>
            </div>
            <div class="no-coupons" v-if="expiredCouponList.length == 0">{{ $t('lang.intimate.noCouponTip') }}</div>
          </div>
        </van-tab>
      </van-tabs>
      <div class="confirm-btn" :class="{ 'no-click': (active == 0 && (validCouponListSort.length == 0 || this.chooseCouponId == null)) || active == 1 }" @click="handleConfirm">
        {{ $t('lang.confirm') }}
      </div>
      <div :style="{ width: '100%', height: `${bottomBarHeight}px` }"></div>
    </van-popup>
  </div>
</template>

<script>
// store 优惠卷
export default {
  props: {
    active: {
      default: 0
    },
    showCouponPopup: {},
    tebTit: {},
    validCouponListSort: {}, // 排序之后有效的优惠劵
    maxCoupon: {}, // 最大的优惠劵
    expiredCouponList: {} // 无效的优惠劵,
  },
  data() {
    return {
      chooseCouponId: null,
      chooseCouponOption: {}
    }
  },
  methods: {
    close() {
      this.$emit('close', false)
    },

    // 选中优惠卷
    chooseCoupon(item) {
      this.chooseCouponOption = item
      this.chooseCouponId = item.couponRecordId
    },

    // 确定选中
    handleConfirm() {
      if (this.chooseCouponId) {
        if (this.chooseCouponOption) {
          this.$emit('confirmChooseCouponId', this.chooseCouponOption)
        } else {
          this.$emit('confirmChooseCouponId', this.maxCoupon)
        }
      } else {
        this.close()
      }
    }
  },
  watch: {
    maxCoupon: {
      deep: true,
      immediate: true,
      handler(newVal) {
        if (newVal && newVal.couponRecordId) {
          this.chooseCouponId = newVal.couponRecordId
        }
      }
    },
    validCouponListSort: {
      deep: true,
      immediate: true,
      handler(newVal) {
        if (newVal) {
          this.maxCoupon = this.validCouponListSort[0] || null
          this.$forceUpdate()
        }
      }
    }
  }
}
</script>

<style lang="less" scoped>
.coupon-dia {
  font-family: Inter;
  .van-popup {
    width: 100%;
    min-height: 432px;
    padding: 20px 24px;
    overflow: hidden;
  }
  .title {
    width: 100%;
    height: 20px;
    font-weight: bold;
    font-size: 17px;
    color: #333333;
    line-height: 20px;
    text-align: center;
  }
  .tab {
    height: 260px;
    overflow-y: auto !important;
    color: #333333;
  }

  .coupon {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    height: 66px;
    padding: 0 16px 0 0;
    margin-bottom: 7px;
    color: #ccc;
    font-family: Inter;
  }

  .expired-coupon {
    filter: grayscale(1);
    pointer-events: none;
  }

  .coupon,
  .expired-coupon {
    position: relative;
    .coupon-bg {
      width: 100%;
      height: 100%;
      position: absolute;
      left: 0;
      top: 0;
      z-index: -1;
    }
    .left {
      display: flex;
      align-items: center;
      .left-num {
        width: 90px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        .money-icon {
          width: 36px;
          height: 36px;
        }
        .money-num {
          margin-bottom: 10px;
          font-weight: bold;
          font-size: 20px;
          color: #ff483c;
          line-height: 24px;
        }
      }
      .dis-text {
        margin-left: 16px;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        .text {
          margin-bottom: 6px;
          font-weight: 600;
          font-size: 14px;
          color: #333333;
        }
        .text-tip {
          display: flex;
          align-items: center;
          font-size: 10px;
          > img {
            width: 12px;
            margin: 0 2px;
          }
        }
      }
    }

    .right {
      display: flex;
      align-items: center;

      .coupon-num {
        display: flex;
        flex-direction: column;
        align-items: flex-end;
        .radio {
          width: 20px;
          height: 20px;
          margin-bottom: 8px;
          border-radius: 50%;
          border: 1px solid #999999;
        }
        .radio-checked {
          font-size: 20px;
          color: #fd3d3b;
          border: 1px solid #999999;
          border-radius: 50%;
        }
        .num {
          font-weight: 600;
          font-size: 20px;
          color: #fd3d3b;
          line-height: 20px;
        }
        .text {
          display: block;
          font-weight: 400;
          font-size: 10px;
          color: #999999;
          margin-top: 6px;
        }
        .expired {
          width: 68px;
          height: 24px;
          border-radius: 12px;
          border: 1px solid #cccccc;
          font-family: Inter;
          font-weight: 500;
          font-size: 14px;
          color: #cccccc;
          line-height: 24px;
          text-align: center;
        }
      }
    }
  }

  .confirm-btn {
    width: 289px;
    height: 40px;
    margin: 17px auto 0;
    background: #a338fc;
    border-radius: 20px;

    font-family: Inter;
    font-weight: 500;
    font-size: 16px;
    color: #ffffff;
    line-height: 40px;
    text-align: center;
  }

  .no-click {
    pointer-events: none;
    background: #e1e1e1;
  }

  .no-coupons {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    font-family: Inter;
    font-weight: 400;
    font-size: 17px;
    color: #999999;
    line-height: 20px;
  }
}

html[lang='ar'] {
  .coupon,
  .expired-coupon {
    padding: 0 0 0 16px;
    .coupon-bg {
      transform: rotateY(180deg);
    }
  }
}
</style>

<style lang="scss" scoped>
::v-deep .van-tab {
  font-size: 15px;
  color: #999999;
}
::v-deep .van-tab--active {
  color: #333333;
  font-weight: 600;
}
::v-deep .van-tabs__line {
  display: none;
}

// 去掉滚动条
::-webkit-scrollbar {
  display: none;
}
::-webkit-scrollbar-track {
  display: none;
}
</style>
